import React from 'react';

const ProfileHeader = ({ showTableauLink = true, onNavigate }) => (
  <div className="container">
    <div className="profile-header">
      <div className="profile-content">
        <div className="profile-avatar">
          <img 
            src="/profile.jpeg" 
            alt="Magouille" 
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              objectFit: 'cover'
            }}
          />
        </div>
        <div className="profile-info">
          <div className="profile-name">Magouille</div>
          <div className="profile-desc">Les meilleurs bonus casinos séléctionnés par Magouille</div>
        </div>
      </div>
      {showTableauLink ? (
        <div className="profile-link" onClick={() => onNavigate && onNavigate(1)}>
          Voir le tableau de blackjack →
        </div>
      ) : (
        <div className="profile-link" onClick={() => onNavigate && onNavigate(0)}>
          Voir les bonus →
        </div>
      )}
    </div>
  </div>
);

export default ProfileHeader; 